import { NavigateFunction } from "react-router-dom";
import { HEADERMENU_PATH } from "../../../../routes/RoutesURL";
import { CampaignList } from "../campaign/redux/type";

const userDashboardColumn = (navigate: NavigateFunction) => ({
    title: "Created by",
    dataIndex: "user_name",
    width: 160,
    render: (_: string, campaign: CampaignList) => {
        const userName = campaign.user_name || campaign.username;
        const userToken = campaign.user_token;
        if (!userName) {
            return <span>--</span>;
        }

        return userToken ? (
            <button
                type="button"
                className="cursor-pointer text-blue-700 underline"
                onClick={() => navigate(`${HEADERMENU_PATH.userDashboard}${encodeURIComponent(userToken)}`)}
            >
                {userName}
            </button>
        ) : (
            <span>{userName}</span>
        );
    },
});

export default userDashboardColumn;
